// removed by extract-text-webpack-plugin
module.exports = {"flex-shrink-0":"AlertBanner__flex-shrink-0","flexShrink0":"AlertBanner__flex-shrink-0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/AlertBanner/AlertBanner.scss
// module id = 1742
// module chunks = 8